import React from 'react';
import {
  LineChartOutlined,
  ShoppingOutlined,
  BookOutlined,
  SettingOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { RBAC_RESOURCES } from '../../config/rbac';
import type { RbacResource } from '../../services/rbac/rbacService';

export const PERMISSION_COLORS: Record<string, string> = {
  read: '#3b82f6',
  write: '#f59e0b',
  delete: '#ef4444',
  manage: '#8b5cf6',
};

export const PERMISSION_LABELS: Record<string, string> = {
  read: 'Чт',
  write: 'Зп',
  delete: 'Уд',
  manage: 'Упр',
};

export const PERMISSION_FULL_LABELS: Record<string, string> = {
  read: 'Чтение',
  write: 'Запись',
  delete: 'Удаление',
  manage: 'Управление',
};

export const PERMISSION_PRIORITIES: Record<string, number> = {
  manage: 4,
  delete: 3,
  write: 2,
  read: 1,
};

export const getCategoryIcon = (categoryKey: string): React.ReactNode => {
  const icons: Record<string, React.ReactNode> = {
    sales: <LineChartOutlined />,
    purchase: <ShoppingOutlined />,
    references: <BookOutlined />,
    admin: <SettingOutlined />,
  };
  return icons[categoryKey] || <CheckCircleOutlined />;
};

export const getCategoryName = (categoryKey: string): string => {
  const names: Record<string, string> = {
    sales: 'План продаж',
    purchase: 'План закупок',
    references: 'Справочники',
    admin: 'Администрирование',
  };
  return names[categoryKey] || categoryKey;
};

export function getResourceDescription(resourceValue: string): string | undefined {
  const config = Object.values(RBAC_RESOURCES).find(r => r.value === resourceValue);
  return config?.description;
}

export function getParentValue(resource: RbacResource): string | null {
  const config = Object.values(RBAC_RESOURCES).find(r => r.value === resource.value);
  if (config && 'parent' in config && config.parent) {
    return config.parent;
  }
  return null;
}

export function isParentResource(resource: RbacResource): boolean {
  return Object.values(RBAC_RESOURCES).some(
    r => 'parent' in r && r.parent === resource.value
  );
}

export function getChildResourceValues(parentValue: string): string[] {
  return Object.values(RBAC_RESOURCES)
    .filter(r => 'parent' in r && r.parent === parentValue)
    .map(r => r.value);
}
